export const COMPANY_INFO = {
  name: "Kokholm Byg",
  owner: "Kokholm Byg",
  phone: "40 94 52 61",
  phoneRaw: "+4540945261",
  email: "kokholm@kokholmbyg.dk",
  cvr: "46164296",
  address: "Tingagerparken 11",
  city: "7500 Holstebro",
  fullAddress: "Tingagerparken 11, 7500 Holstebro",
  logoUrl: "https://assets.auxodev.dk/assets/2f17f913-822d-430f-9ea1-0cc9e6665c42/kokholm-logo.png",
  facebookUrl: "https://www.facebook.com/Kokholmbyg-1557913711159361"
};

export const SERVICES_LIST = [
  {
    title: "Flise- og klinkearbejde",
    slug: "vi-tilbyder-laegning-af-fliser-indendoers",
    gallerySlug: "flise-og-klinkearbejde",
    icon: "fa-solid fa-border-all",
    shortDescription: "Lægning af fliser, klinker, granit og marmor i badeværelser, køkkener og opholdsrum med høj præcision."
  },
  {
    title: "Badeværelser",
    slug: "vi-tilbyder-renovering-af-badevaerelse",
    gallerySlug: "badevaerelser",
    icon: "fa-solid fa-bath",
    shortDescription: "Specialister i komplet renovering, ombygning og etablering af nye moderne badeværelser."
  },
  {
    title: "Reparationer",
    slug: "vi-tilbyder-reparationer",
    gallerySlug: "reparationer",
    icon: "fa-solid fa-hammer",
    shortDescription: "Hurtig udrykning og grundig reparation af murværk, stormskader, rørskader, facader og trapper."
  },
  {
    title: "Renovering",
    slug: "vi-tilbyder-renovering",
    gallerySlug: "renovering",
    icon: "fa-solid fa-house-chimney-crack",
    shortDescription: "Gennemgribende renovering af privatboliger, køkkener, bad og historiske byhuse."
  },
  {
    title: "Tilbygning",
    slug: "vi-tilbyder-tilbygning",
    gallerySlug: "tilbygning",
    icon: "fa-solid fa-square-plus",
    shortDescription: "Ekspertise i udvidelse af boligkvadratmeter og opbygning af nye funktionelle etager."
  },
  {
    title: "Nybyggeri",
    slug: "vi-tilbyder-diversenybyg",
    gallerySlug: "nybyggeri",
    icon: "fa-solid fa-trowel-bricks",
    shortDescription: "Kvalitetsbyggeri af villaer og parcelhuse i fagentreprise med mere end 30 års erfaring."
  }
];
